var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BAutocompleteSelect',_vm._g(_vm._b({ref:"autocomplete",attrs:{"label":"Типы файлов","no-data-text":"Тип не найден","options":_vm.options}},'BAutocompleteSelect',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }